import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import TextNumberEntryView from '../../views/textNumberEntryView';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import MenuContext from '../../../context/menuContext';
import styles from './self-test.module.css';
import {useMenu} from '../../../hooks/useMenu';
import TimeZone from './timezone';
import ConfigUnits from './config-unit';
import TimeZOneTN from './time-zoneTN';
import SetDeviceTag from './set-deviceTN';

function DateZoneTN({initiallyDisableKeypress}) {
  const [value, setValue] = useState(10);
  const {onComponent} = useMenu();

  return (
    <>
      <TextNumberEntryView
        chars={specialCharTextNumbers}
        focus={3}
        onChange={v => setValue(v)}
        defaultKey1={0}
        defaultKey2={0}
        defaultKey3={0}
        defaultKey4={0}
        defaultKey5={0}
        defaultKey6={0}
        defaultKey7={0}
        defaultKey8={0}
        defaultKey9={0}
        defaultKey10={0}
        defaultKey11={0}
        defaultKey12={0}
        onSave={() => onComponent(<SetDeviceTag initiallyDisableKeypress />)}
        onLeftHold={() => onComponent(<TimeZOneTN initiallyDisableKeypress />)}
        title="Date"
        caption="Enter the current date."
        left="Hold to Cancel"
        right="Hold to Save"
        initiallyDisableKeypress={initiallyDisableKeypress}
      />
      <span className={styles.underConstruction}>** under construction **</span>
    </>
  );
}

export default DateZoneTN;
